<template>
  <div class="text-center">
    <v-overlay :value="isLoading" style="z-index: 300;">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
  </div>
</template>

<script>
  export default {
    name: "LoadingOverlay",

    computed: {
      isLoading() {
        return this.$store.getters.loadingStatus;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/LoadingOverlay.vue